import type { FC } from 'react';

import { useEditStore } from '@xing-com/crate-entity-pages-entity-pages-shared-context-edit-context';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import * as Styled from './gallery-edit-button.styles';

type GalleryEditButtonProps = {
  inFullWidth?: boolean;
};
export const GalleryEditButton: FC<GalleryEditButtonProps> = ({
  inFullWidth = false,
}) => {
  const { pageContext } = usePageContext();
  const isEditing = useEditStore(({ isEditing }) => isEditing);

  if (pageContext.isFreePage || !isEditing || !pageContext.isCompanyPage) {
    return null;
  }

  return (
    <Styled.GalleryEditButton
      size={'small'}
      showIcon
      $inFullWidth={inFullWidth}
      to={`${pageContext.basePath}/${pageContext.pageSlug}/edit/gallery`}
      data-testid="edit-gallery-preview"
    />
  );
};
